
import { Input } from "@/components/ui/input";
import { usePermissions } from "@/hooks/use-permissions";
import { Search } from "lucide-react";
import UserFilters from "./UserFilters";
import { UserFilters as UserFiltersType, UserSortOption } from "./UserFilters";
import { Country } from "./useCountriesAndConstituencies";

interface UserManagementHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  totalUsers: number;
  countries: Country[];
  filters: UserFiltersType;
  setFilters: (filters: UserFiltersType) => void;
  sortOption: UserSortOption;
  setSortOption: (sortOption: UserSortOption) => void;
}

const UserManagementHeader = ({ 
  searchQuery, 
  setSearchQuery, 
  totalUsers,
  countries,
  filters,
  setFilters,
  sortOption,
  setSortOption
}: UserManagementHeaderProps) => {
  const { isSuperAdmin } = usePermissions();
  
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl md:text-2xl font-bold">User Management</h1>
        <p className="text-sm md:text-base text-gray-500">
          {isSuperAdmin() 
            ? "Manage all users across the NationCard™ platform" 
            : "Manage users within your assigned country"}
        </p>
        <p className="text-sm text-gray-500">{totalUsers} users found</p>
      </div>
      
      <div className="relative w-full">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" />
        <Input
          placeholder="Search users by name, email, role or country..."
          className="w-full pl-9"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="pt-1">
        <UserFilters 
          countries={countries}
          filters={filters}
          onFilterChange={setFilters}
          sortOption={sortOption}
          onSortChange={setSortOption}
        />
      </div>
    </div>
  );
};

export default UserManagementHeader;
